export const TABLE_COLUMNS = [
  {
    key: 'sale_date',
    label: 'Sale Date',
    className: 'col-sale-date',
    sortable: true,
    width: '110px'
  },
  {
    key: 'address',
    label: 'Property',
    className: 'col-property',
    sortable: true,
    width: '25%'
  },
  {
    key: 'upset_value',
    label: 'Upset Value',
    className: 'col-upset',
    sortable: true,
    width: '130px'
  },
  {
    key: 'downpayment',
    label: 'Est. Downpayment',
    className: 'col-downpayment',
    sortable: true,
    width: '180px'
  },
  {
    key: 'zillow_estimate',
    label: 'Zillow Est.',
    className: 'col-zillow',
    sortable: true,
    width: '180px'
  },
  {
    key: 'profit',
    label: 'Profit $',
    className: 'col-profit',
    sortable: true,
    width: '130px'
  }
];

export const BADGE_CONFIGS = {
  zillow: {
    color: 'bg-blue-500 text-white',
    label: 'Zillow'
  },
  'zillow-simulated': {
    color: 'bg-yellow-100 text-yellow-800',
    label: 'Simulated'
  },
  attom: {
    color: 'bg-green-100 text-green-800',
    label: 'ATTOM'
  },
  redfin: {
    color: 'bg-purple-100 text-purple-800',
    label: 'Redfin'
  },
  default: {
    color: 'bg-gray-100 text-gray-600',
    label: 'Unknown'
  }
};